import { TagGroup } from "@redotech/redo-model/support/tag-group-zod-schema";
import { createContext } from "react";

export interface ConversationValidationResult {
  canClose: boolean;
  missingTagGroups: TagGroup[];
}

export interface ConversationCloseValidationContextType {
  revalidate?: (conversationId: string) => Promise<void>;
  validationResult?: ConversationValidationResult | null;
  isValidating?: boolean;
}

export const ConversationCloseValidationContext =
  createContext<ConversationCloseValidationContextType>({});
